// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"f42b85d119271c75bcd7236cedc6fbe051a1d3b7"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/hub";import * as Sentry from '@sentry/nextjs';

Sentry.init({
 dsn: 'https://fdc1cac5b9a82acab9c3461b7c580ada@o311348.ingest.us.sentry.io/4507628874694656',

 // Adjust this value in production, or use tracesSampler for greater control
 tracesSampleRate: 1,

 // Setting this option to true will print useful information to the console while you're setting up Sentry.
 debug: false,
 replaysOnErrorSampleRate: 1.0,

 // This sets the sample rate to be 10%. You may want this to be 100% while
 // in development and sample at a lower rate in production
 replaysSessionSampleRate: 0.1,

 // You can remove this option if you're not planning to use the Sentry Session Replay feature:
 integrations: [
  Sentry.replayIntegration({
   // Additional Replay configuration goes in here, for example:
   maskAllText: true,
   blockAllMedia: true,
  }),
 ],

 environment:
  process.env.NODE_ENV == 'development'
   ? 'development'
   : process.env.environment,
});
